import { AppAccent } from 'src/app/core/types/app-accent.type';
import { AppVisualContextService } from '../../services/app-visual-context.service';
import { HostBinding, inject, Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef } from '@angular/core';
import { NanoCardAccordionButton } from 'src/app/core/models/minicardbutton.model';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Component({
  selector: 'app-nano-card-accordion',
  templateUrl: './nano-card-accordion.component.html',
  styleUrl: './nano-card-accordion.component.css',
})
export class NanoCardAccordionComponent implements OnInit, OnChanges {
  // Atributos personalizados para o componente
  @Input() accent?: AppAccent;
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForInputs(this.accent);
  }

  @Input({ required: true }) title: NullSafe<string>;
  @Input() headerButtons: NanoCardAccordionButton[] | null = [];
  // Aceita qualquer template
  @Input() headerContent?: TemplateRef<any>;
  @Input() headerContentWidth: 'default' | 'compact' = 'default';
  get headerContentClass(): string {
    return `header-content-width-${this.headerContentWidth === 'compact' ? 45 : 65}`;
  }

  ngOnInit(): void {
    this.validateHeaderButtons();
  }

  ngOnChanges(): void {
    this.validateHeaderButtons();
  }

  private validateHeaderButtons(): void {
    const typesParamsLink = ['number', 'string', 'boolean'];
    this.headerButtons = this.headerButtons.filter(button => button); // Remove elementos null ou undefined
    this.headerButtons.forEach(button => {
      if (button.callBack && button.routerLink) {
        throw new Error('callBack e routerLink não podem ser utilizados simultaneamente!');
      }
      if (button.routerLink && button.params) {
        let paramKeys = Object.keys(button.params);
        paramKeys.forEach(key => {
          let paramType = typeof button.params[key];
          if (button.params[key] == null) return;
          if (!typesParamsLink.includes(paramType)) {
            throw new Error(`Tipo de parâmetro '${key}' não é suportado para um routerLink. Os tipos suportados são: ${typesParamsLink.join(', ')}.`);
          }
        });
      }
    });
  }
}
